import {call, put, takeLeading} from 'redux-saga/effects';
import {REDUCE_GET_QA_DICT_TYPE_GROUP, REDUCER_GET_CURRENT_PST, SAGA_GET_CURRENT_PST, SAGA_GET_QA_DICT_TYPE_GROUP, SAGA_USER_LOGOUT, SAGA_GET_PST_By_Vigo} from '@store/types';
import {getQaDictTypeGroup, getQAUserPST,getPSTByVigoUserId, userLogout, logoutGtrs} from '@api';
import {appid, GTRS_GDUSERID} from '@const';
import {cookie} from '@gaodun.com/gtools';
import {loginTimeout} from '@utils';

function* _getCurrentPST({params, cb}: any) {
    try {
        // @ts-ignore
        const res = yield call(getQAUserPST, params);
        if (res.data && +res.data.status === 0) {
            yield put({
                type: REDUCER_GET_CURRENT_PST,
                data: {
                    ...params,
                    result: res.data.result
                }
            });
            return cb && cb(res.data.result);
        }
        return cb && cb(null);
    } catch (e) {
        return cb && cb(null);
    }
}

function* _getPSTByVigoUserId({ params, cb }: any) {

    try {
        // @ts-ignore
        const res = yield call(getPSTByVigoUserId, params.vigoUserId);
        if (res.data && +res.data.status === 0) {
            yield put({
                type: REDUCER_GET_CURRENT_PST,
                data: {
                    ...params,
                    result: res.data.result
                }
            });
            return cb && cb(res.data.result);
        }
        return cb && cb(null);
    } catch (e) {
        return cb && cb(null);
    }
}

function* _getQaDictTypeGroup({cb}: any) {
    try {
        // @ts-ignore
        const res = yield call(getQaDictTypeGroup, {
            groupCode: 'QA_USER'
        });
        if (res.data && +res.data.status === 0) {
            yield put({
                type: REDUCE_GET_QA_DICT_TYPE_GROUP,
                data: res.data.result.qaUser
            });
            return cb && cb(true);
        }
        return cb && cb(false);
    } catch (e) {
        console.log(e);
        return cb && cb(false);
    }
}

function* _userLogout() {
    yield call(logoutGtrs,  cookie.getCookie('GDUSERID'));
    // @ts-ignore
    const res = yield call(userLogout, {
        appid: appid,
        token: cookie.getCookie('accessAdmintoken')
    });

    cookie.setCookie('accessToken', '', -1);
    cookie.setCookie('refreshToken', '', -1);
    cookie.setCookie('SAAS_USER_NAME', '', -1);
    cookie.setCookie('accessAdmintoken', '', -1);
    cookie.setCookie('refreshAdmintoken', '', -1);
    cookie.setCookie('GDUSERID', '', -1);
    cookie.setCookie(GTRS_GDUSERID, '', -1);
    sessionStorage.clear();
    localStorage.setItem('GTRS_POP', '');
    if (res.data && res.data.status === 0) {
        loginTimeout('退出登录', 'success');
    }
}

export default function* commonSaga() {
    yield takeLeading(SAGA_GET_CURRENT_PST, _getCurrentPST);
    yield takeLeading(SAGA_GET_PST_By_Vigo, _getPSTByVigoUserId);
    yield takeLeading(SAGA_GET_QA_DICT_TYPE_GROUP, _getQaDictTypeGroup);
    yield takeLeading(SAGA_USER_LOGOUT, _userLogout);
}